import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  
  if (!token) {
    // Rediriger vers la page de connexion si pas de token
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
